import React, { Dispatch, SetStateAction, useState } from "react";
import { Input } from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, InputField } from "../../components";
import CloseIcon from "@mui/icons-material/Close";
import "../auth/Auth.scss";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch } from "../../hooks/store";
import { toggleAuthModal } from "../../reducers/generalSlice";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { UploadMedia } from "../../utils/uploadMedia";
import {
  Loader,
  STORAGE_KEYS,
  errorToast,
  getFromStorage,
  successToast,
} from "../../helpers";

import useAuth from "../../hooks/useAuth";
import { setCredentials } from "../../reducers/authSlice";
import { usePostChangePasswordMutation } from "../../service/Auth";
import useTranslation from "../../hooks/Translation";

type props = {
  closeModal: () => void;
  setPhone: Dispatch<SetStateAction<boolean>>;
};

const ChangePassword = ({ closeModal, setPhone }: props) => {
  const translation = useTranslation();
  const user = useAuth();
  const dispatch = useAppDispatch();

  const [changePassword, { isLoading }] = usePostChangePasswordMutation();

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
      oldPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string()
        .label("Old Password")
        .required(translation.validations.old_pass_required),

      newPassword: Yup.string()
        .label("new Password")
        .required(translation.validations.new_pass_required)
        .notOneOf(
          [Yup.ref("oldPassword"), null],
          translation.validations.new_pass_validation
        ),

      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], translation.validations.password_match)
        .required(translation.validations.cofirmPass_required),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);

      let data = {
        oldPassword: formik.values.oldPassword,
        password: formik.values.newPassword,
      };

      try {
        const response = await changePassword(data).unwrap();
        if (response?.statusCode === 200) {
          successToast(translation.toast_messages.password_updated);
          closeModal();
        }
      } catch (error: any) {
        errorToast(error?.data?.message || "");
        console.log(error, "errorrr");
      }
      formik.setSubmitting(false);
    },
  });

  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="AuthWrap">
        <div className="cross ">
          <CloseIcon
            onClick={() =>
              dispatch(
                toggleAuthModal({
                  isAuthModalVisible: false,
                  ModalType: "",
                })
              )
            }
          />
        </div>
        <h2 style={{ marginBottom: "15px" }}>
          {translation.Auth.change_password.change}
        </h2>

        <form onSubmit={formik.handleSubmit}>
          <InputField
            placeholder={translation.Auth.change_password.old_pass}
            password
            name="oldPassword"
            id="oldPassword"
            value={formik.values.oldPassword}
            onChange={(val) => {
              if (val.target.value === " " || val.target.value === ".") {
              } else {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={formik.touched.oldPassword && formik.errors.oldPassword}
          />
          <InputField
            placeholder={translation.Auth.change_password.new_pass}
            password
            name="newPassword"
            id="newPassword"
            value={formik.values.newPassword}
            onChange={(val) => {
              if (val.target.value === " " || val.target.value === ".") {
              } else {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={formik.touched.newPassword && formik.errors.newPassword}
          />
          <InputField
            placeholder={translation.Auth.Sign_up.confirm_password}
            password
            name="confirmPassword"
            id="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={(val) => {
              if (val.target.value === " " || val.target.value === ".") {
              } else {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
          />

          <Button value={translation.Globals.submit} />
        </form>
      </div>
      <div style={{ marginBottom: 20 }} />
    </div>
  );
};

export default ChangePassword;
